var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoTemperature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 2.5C10.2051 2.5 8.75 3.95507 8.75 5.75V13.9073C8.75 14.1177 8.64553 14.3689 8.41561 14.6331C7.69008 15.4668 7.25 16.558 7.25 17.75C7.25 20.3734 9.37665 22.5 12 22.5C14.6234 22.5 16.75 20.3734 16.75 17.75C16.75 16.558 16.3099 15.4668 15.5844 14.6331C15.3545 14.3689 15.25 14.1177 15.25 13.9073V5.75C15.25 3.95507 13.7949 2.5 12 2.5ZM12.375 16.0403C13.1613 16.2119 13.7501 16.9122 13.7501 17.75C13.7501 18.7165 12.9666 19.5 12.0001 19.5C11.0336 19.5 10.25 18.7165 10.25 17.75C10.25 16.9122 10.8387 16.2119 11.625 16.0403L11.625 5.75C11.625 5.54289 11.7929 5.375 12 5.375C12.2071 5.375 12.375 5.54289 12.375 5.75L12.375 16.0403Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5C17.0858 5 16.75 5.33579 16.75 5.75C16.75 6.16421 17.0858 6.5 17.5 6.5H19C19.4142 6.5 19.75 6.16421 19.75 5.75C19.75 5.33579 19.4142 5 19 5H17.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8C17.0858 8 16.75 8.33579 16.75 8.75C16.75 9.16421 17.0858 9.5 17.5 9.5H19C19.4142 9.5 19.75 9.16421 19.75 8.75C19.75 8.33579 19.4142 8 19 8H17.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11C17.0858 11 16.75 11.3358 16.75 11.75C16.75 12.1642 17.0858 12.5 17.5 12.5H19C19.4142 12.5 19.75 12.1642 19.75 11.75C19.75 11.3358 19.4142 11 19 11H17.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 5.75L12.375 16.0403C13.1613 16.2119 13.7501 16.9122 13.7501 17.75C13.7501 18.7165 12.9666 19.5 12.0001 19.5C11.0336 19.5 10.25 18.7165 10.25 17.75C10.25 16.9122 10.8387 16.2119 11.625 16.0403L11.625 5.75C11.625 5.54289 11.7929 5.375 12 5.375C12.2071 5.375 12.375 5.54289 12.375 5.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoTemperature);
export default __webpack_public_path__ + "static/media/DuoTemperature.15f8a394021437a653bf1464dea47776.svg";
export { ForwardRef as ReactComponent };